import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=128ce526&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "../../theme/button.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Button.vue?vue&type=style&index=1&id=128ce526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128ce526",
  null
  
)

export default component.exports